// extracted by mini-css-extract-plugin
export default {"paginationWrap":"tableArchive_paginationWrap__aciXm","row":"tableArchive_row__oQ+Pt"};